/**
 * Resolves Intelligems group list prices for custom promo math.
 * After a price test starts, Shopify catalog is the highest test price;
 * control still needs qty-1 10% / Fall Sale 20%/25% off $64.99, not $69.99.
 *
 * window.igData.price.getPriceByVariantId() returns dollars ("64.99") or null.
 * https://docs.intelligems.io/developer-resources/javascript-api/price-object
 */
(function () {
  var READY_EVENT = 'rio:ig-price-ready';
  var WAIT_MS = 4000;
  var readyPromise;

  function dollarsToCents(value) {
    if (value == null || value === '') return null;
    var n = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (!isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function getIgPriceDollars(variantId) {
    var api = window.igData && window.igData.price;
    if (!api || variantId == null || variantId === '') return null;
    try {
      var raw = api.getPriceByVariantId(String(variantId));
      return raw == null ? null : raw;
    } catch (e) {
      return null;
    }
  }

  function getListPriceCents(variantId, fallbackCents) {
    var fallback = parseInt(fallbackCents, 10) || 0;
    var ig = dollarsToCents(getIgPriceDollars(variantId));
    return ig != null && ig > 0 ? ig : fallback;
  }

  function applyPercentOffCents(priceCents, discountPct) {
    if (!(priceCents > 0) || !(discountPct > 0)) return priceCents;
    return priceCents - Math.round((priceCents * discountPct) / 100);
  }

  // Liquid: times 90 / 100, plus 12, / 25 * 25 → nearest $0.25 ($64.99 → $58.50).
  function qtyOneSaleCents(priceCents) {
    if (!(priceCents > 0)) return 0;
    var raw = Math.floor((priceCents * 90) / 100);
    return Math.floor((raw + 12) / 25) * 25;
  }

  function volumeDiscountPct(unitCount) {
    if (unitCount >= 3) return 25;
    if (unitCount >= 2) return 20;
    if (unitCount === 1) return 10;
    return 0;
  }

  function computePromoTotalCents(unitPricesCents, isGiftCard) {
    var units = (unitPricesCents || []).filter(function (cents) {
      return cents > 0;
    });
    if (!units.length) return 0;
    if (isGiftCard) {
      return units.reduce(function (sum, cents) {
        return sum + cents;
      }, 0);
    }
    if (units.length === 1) return qtyOneSaleCents(units[0]);
    var pct = volumeDiscountPct(units.length);
    if (pct <= 0) {
      return units.reduce(function (sum, cents) {
        return sum + cents;
      }, 0);
    }
    return units.reduce(function (sum, cents) {
      return sum + applyPercentOffCents(cents, pct);
    }, 0);
  }

  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        window.DEFAULT_MONEY_FORMAT ||
        (window.Shopify && window.Shopify.money_format) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format).replace(/(\p{Sc})[\u00A0\u202F ]+(?=\d)/gu, '$1');
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + amount;
    }
  }

  function setText(el, cents) {
    if (!el) return;
    el.textContent = formatMoney(cents);
  }

  function hydrateOwnedPrices() {
    document.querySelectorAll('[data-rio-ig-price]').forEach(function (el) {
      if (el.getAttribute('data-gift-card') === 'true') return;
      var variantId = el.getAttribute('data-variant-id');
      var fallback = parseInt(el.getAttribute('data-list-cents'), 10) || 0;
      var listCents = getListPriceCents(variantId, fallback);
      if (!listCents) return;
      el.setAttribute('data-list-cents', String(listCents));

      var kind = el.getAttribute('data-rio-ig-price');
      if (kind === 'card') {
        var regular = el.querySelector('.f-price__regular .f-price-item--regular');
        var compare = el.querySelector('.f-price__sale .f-price-item--regular s');
        var sale = el.querySelector('.f-price__sale .f-price-item--sale');
        setText(regular, listCents);
        setText(compare, listCents);
        if (sale) setText(sale, qtyOneSaleCents(listCents));
        return;
      }

      if (kind === 'pdp') {
        // Qty 2+ slash / badge markup is owned by buy-buttons; do not clobber it.
        if (el.querySelector('.price__compare')) return;
        setText(el.querySelector('.price__regular'), listCents);
        var unit = el.querySelector('#js-product-unit-price');
        if (unit) unit.setAttribute('data-price', String(listCents));
        return;
      }

      if (kind === 'viewing') {
        setText(el.querySelector('.city-product-dropdown__item-price--compare'), listCents);
        setText(el.querySelector('.city-product-dropdown__item-price--discounted'), qtyOneSaleCents(listCents));
        return;
      }

      if (kind === 'addon') {
        var twenty = applyPercentOffCents(listCents, 20);
        var twentyFive = applyPercentOffCents(listCents, 25);
        el.querySelectorAll('.city-product-dropdown__item-price--compare').forEach(function (node) {
          setText(node, listCents);
        });
        el.querySelectorAll('[data-discount-tier="tier-20"].city-product-dropdown__item-price--discounted').forEach(function (node) {
          setText(node, twenty);
        });
        el.querySelectorAll('[data-discount-tier="tier-30"].city-product-dropdown__item-price--discounted').forEach(function (node) {
          setText(node, twentyFive);
        });
        return;
      }

      if (kind === 'drawer-card') {
        var pct = parseInt(el.getAttribute('data-discount-pct'), 10) || 10;
        var saleEl = el.querySelector('.product-card__discounted-price');
        var compareEl = el.querySelector('.product-card__original-price');
        var badge = el.querySelector('.product-card__discount-badge');
        if (pct >= 10) {
          if (compareEl) compareEl.style.display = '';
          setText(compareEl, listCents);
          setText(saleEl, pct === 10
            ? qtyOneSaleCents(listCents)
            : applyPercentOffCents(listCents, pct));
          if (saleEl) saleEl.style.marginLeft = '8px';
          if (badge) {
            badge.hidden = false;
            badge.textContent = pct === 10 ? '10% off automatically applied' : pct + '% off';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          setText(saleEl, listCents);
          if (saleEl) saleEl.style.marginLeft = '';
          if (badge) {
            badge.hidden = true;
            badge.textContent = '';
          }
        }
      }
    });
  }

  function whenReady() {
    if (readyPromise) return readyPromise;
    readyPromise = new Promise(function (resolve) {
      var settled = false;
      var done = function () {
        if (settled) return;
        settled = true;
        resolve(window.igData || null);
        document.dispatchEvent(new CustomEvent(READY_EVENT));
      };

      if (window.igData && window.igData.price) {
        done();
        return;
      }

      window.addEventListener('ig:ready', done, { once: true });

      var prev = window.onIgReady;
      if (typeof prev === 'function') {
        window.onIgReady = [prev, done];
      } else if (Array.isArray(prev)) {
        prev.push(done);
      } else {
        window.onIgReady = done;
      }

      setTimeout(done, WAIT_MS);
    });
    return readyPromise;
  }

  function hydrate() {
    hydrateOwnedPrices();
  }

  var hydrateQueued = false;
  function scheduleHydrate() {
    if (hydrateQueued) return;
    hydrateQueued = true;
    requestAnimationFrame(function () {
      hydrateQueued = false;
      hydrate();
    });
  }

  function nodeHasIgPrice(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute && node.getAttribute('data-rio-ig-price')) return true;
    return !!(node.querySelector && node.querySelector('[data-rio-ig-price]'));
  }

  function watchForNewCards() {
    if (!document.body || watchForNewCards.started) return;
    watchForNewCards.started = true;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (nodeHasIgPrice(added[j])) {
            scheduleHydrate();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.RioIgPrice = {
    getListPriceCents: getListPriceCents,
    applyPercentOffCents: applyPercentOffCents,
    qtyOneSaleCents: qtyOneSaleCents,
    volumeDiscountPct: volumeDiscountPct,
    computePromoTotalCents: computePromoTotalCents,
    formatMoney: formatMoney,
    whenReady: whenReady,
    hydrate: hydrate,
    scheduleHydrate: scheduleHydrate,
  };

  whenReady().then(function () {
    hydrate();
    requestAnimationFrame(hydrate);
    setTimeout(hydrate, 120);
    setTimeout(hydrate, 400);
    watchForNewCards();
  });

  document.addEventListener('collection:rerendered', scheduleHydrate);
})();
